import { ComputedProductStatus, ProductPackagingType } from "@/graphql/codegen/graphql"

export const PRODUCT_STATUS_LABEL_MAP: Record<ComputedProductStatus, string> = {
  [ComputedProductStatus.Active]: "Active",
  [ComputedProductStatus.Inactive]: "Inactive",
  [ComputedProductStatus.Discontinued]: "Discontinued",
  [ComputedProductStatus.PendingApproval]: "Pending",
}

export const PRODUCT_STATUS_CHIP_COLOR_MAP: Record<ComputedProductStatus, "success" | "warning" | "error" | "default"> =
  {
    [ComputedProductStatus.Active]: "success",
    [ComputedProductStatus.PendingApproval]: "warning",
    [ComputedProductStatus.Inactive]: "error",
    [ComputedProductStatus.Discontinued]: "default",
  }

export const PRODUCT_PACKAGING_TYPE_TO_LABEL: Record<ProductPackagingType, string> = {
  [ProductPackagingType.Bag]: "Bag",
  [ProductPackagingType.Bale]: "Bale",
  [ProductPackagingType.Box]: "Box",
  [ProductPackagingType.Bulk]: "Bulk",
  [ProductPackagingType.Can]: "Can",
  [ProductPackagingType.Carton]: "Carton",
  [ProductPackagingType.Case]: "Case",
  [ProductPackagingType.Container]: "Container",
  [ProductPackagingType.Drum]: "Drum",
  [ProductPackagingType.Each]: "Each",
  [ProductPackagingType.Gaylord]: "Gaylord",
  [ProductPackagingType.LinedPaperBag]: "Lined Paper Bag",
  [ProductPackagingType.LowMeltBag]: "Low Melt Bag",
  [ProductPackagingType.Pail]: "Pail",
  [ProductPackagingType.Pallet]: "Pallet",
  [ProductPackagingType.PaperBag]: "Paper Bag",
  [ProductPackagingType.PlasticBag]: "Plastic Bag",
  [ProductPackagingType.PolyBag]: "Poly Bag",
  [ProductPackagingType.Roll]: "Roll",
  [ProductPackagingType.Sack]: "Sack",
  [ProductPackagingType.Skid]: "Skid",
  [ProductPackagingType.SuperSack]: "Super Sack",
  [ProductPackagingType.Tote]: "Tote",
} as const
